import { Box, makeStyles, Paper, Typography } from '@material-ui/core'
import { Redirect, Route, Switch } from 'react-router-dom'
import { SignIn } from './SignIn'
import { SignUp } from './SignUp'
import { ForgotPassword } from './ForgotPassword'
import { SignOut } from './SignOut'
import { useToken } from '../App'

export function Entrance() {
  const classes = useStyles()

  return (
    <div className={classes.layout}>
      <Paper className={classes.paper}>
        <Switch>
          <Route path="/auth/signin" component={SignIn} />
          <Route path="/auth/signup" component={SignUp} />
          <Route path="/auth/forgot" component={ForgotPassword} />
          <Route path="/auth/signout" component={SignOut} />
          <Redirect to="/auth/signin" />
        </Switch>
        <EntranceForAuth />
      </Paper>
      <Box mt={5}>
        <Copyright />
      </Box>
    </div>
  )
}

function EntranceForAuth() {
  const { userRole } = useToken()

  switch (userRole) {
    case 'admin':
    case 'operator':
      return <Redirect to="/" />
    case 'regular':
      return <Redirect to="/verify" />
    default:
      return null
  }
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      v20260921
      {/* <Link color="inherit" href="#">
        رایمند
      </Link> */}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  layout: {
    width: 480,
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
      margin: theme.spacing(0, 2),
    },
  },
  paper: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
  },
}))
